const { html, text } = window;
export default ({ description, details, note }) => `
    ${description && description.length > 0 ? `<p class='description'>${description}</p>` : ''}
    ${details && details.map((detail) => `<p class='detail'><span class='holdInfoLabel'>${detail.label}: </span><span>${detail.value}</span></p>`).join('')}
    ${note && note.length > 0 ? `<p class='note'>${note}</p>` : ''}
`;
